<script setup lang="ts">
interface Props {
  collapsed: boolean;
}

withDefaults(defineProps<Props>(), {
  collapsed: true,
});

const { t } = useI18n();
const emit = defineEmits(['toggle']);

const clickHandler = (): void => {
  emit('toggle');
};
</script>

<template>
  <button
    :class="['accordion-panel', { _active: !collapsed }]"
    @click="clickHandler"
    :aria-label="collapsed ? t('expand') : t('collapse')"
  >
    <div class="accordion-panel__icon">
      <slot name="icon" />
    </div>
    <span class="accordion-panel__wrapper">
      <slot />
    </span>
  </button>
</template>

<style lang="less">
.accordion-panel {
  .button-reset();

  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  position: relative;
  width: 100%;
  background-color: @color-gallery;
  border-radius: @size-x4;
  transition: @A background-color;

  &__wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: @size-x6 70px @size-x6 @size-x4;
  }

  &__icon {
    display: inline-flex;
    position: absolute;
    top: 50%;
    right: 30px;
    width: @size-x5;
    height: @size-x5;
    transform: translateY(-50%) rotate(0deg);
    transition: transform @A linear;
  }

  &._active &__icon {
    transform: translateY(-50%) rotate(180deg);
  }

  @media @1024 {
    border-radius: @size-x3;

    &__wrapper {
      padding: @size-x5 60px @size-x5 @size-x4;
    }

    &__icon {
      right: @size-x4;
    }
  }
}
</style>
